import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationDetailV2, NotificationState, NotificationType } from "../../../types";
import { FULFILLED, PENDING, REJECTED } from "../../constants";
import { getCategories, getInbox, getInboxDetails, getNotificationDetail } from "./api";
import { NotificationCategoryEnum } from "../../../enums";

const initialState: NotificationState = {
    requestState: FULFILLED,
    notificationInboxDetailState: FULFILLED,
    manageRequests: [],
    myRequests: [],
    pickups: [],
    trades: [],
    allNotifications: [],
    categories: [],

    selectedNoticationIndexDetail: undefined,
    isNotificationDetailLoading: false,
};

export const NotificationSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        resetSelectedNotificationIndexDetail: (state: NotificationState, action: PayloadAction<null>) => {
            state.selectedNoticationIndexDetail = undefined;
        },

        setSelectedCategoryForDetails: (state: NotificationState, action: PayloadAction<string | undefined>) => {
            state.selectedCategoryForDetails = action.payload;
        },
    },
    extraReducers: {
        /** Get categories */
        [getCategories.pending.type]: (state) => {
            state.requestState = PENDING;
        },

        [getCategories.fulfilled.type]: (state, action) => {
            state.requestState = FULFILLED;
            state.categories = action.payload;
        },

        [getCategories.rejected.type]: (state) => {
            state.requestState = REJECTED;
        },

        /** Get inbox */
        [getInbox.pending.type]: (state) => {
            state.requestState = PENDING;
        },

        [getInbox.fulfilled.type]: (state, action) => {
            state.requestState = FULFILLED;
            // Use reduce to create two separate lists: trades and the rest of the notifications
            const [trades, remainingNotifications] = (action.payload.data as NotificationType[]).reduce<
                [NotificationType[], NotificationType[]]
            >(
                (acc, notification) => {
                    if (
                        notification.notificationCategory !== undefined &&
                        notification.notificationCategory == NotificationCategoryEnum.EMP_SHIFT_SWAPPING
                    ) {
                        acc[0].push(notification); // Add to trades
                    } else {
                        acc[1].push(notification); // Add to remainingNotifications
                    }
                    return acc;
                },
                [[], []]
            );

            state.allNotifications = remainingNotifications;
            state.trades = trades;

        },

        [getInbox.rejected.type]: (state) => {
            state.requestState = REJECTED;
        },

        /** Get Inbox Detail */
        [getInboxDetails.pending.type]: (state) => {
            state.notificationInboxDetailState = PENDING;
        },

        [getInboxDetails.fulfilled.type]: (state, action) => {
            state.notificationInboxDetailState = FULFILLED;
            state.selectedNoticationIndexDetail = action.payload;
        },

        [getInboxDetails.rejected.type]: (state) => {
            state.notificationInboxDetailState = REJECTED;
        },

        [getNotificationDetail.pending.type]: (state) => {
            state.isNotificationDetailLoading = true;
        },
        [getNotificationDetail.fulfilled.type]: (state, action: PayloadAction<NotificationDetailV2>) => {
            state.isNotificationDetailLoading = false;
            state.notificationDetail = action.payload;
        },
        [getNotificationDetail.rejected.type]: (state) => {
            state.isNotificationDetailLoading = true;
        },
    },
});

export const { resetSelectedNotificationIndexDetail, setSelectedCategoryForDetails } = NotificationSlice.actions;
export default NotificationSlice.reducer;
